import { PlanLimitConfigs, BillingCycleConfig } from '../types.ts';

export const GUARD_DEFAULT_BILLING_CYCLE = 'MONTHLY';
export const GUARD_DEFAULT_UNIT_COUNT = 100;

export const GUARD_MIN_ENTERPRISE_USER_COUNT = Infinity;

export const guardOfferingSkus = {
	standard: 'atlassian-access-standard-sku',
	premium: 'atlassian-guard-premium-addon-sku',
} as const;

export const guardOfferingSkusArray = Object.values(guardOfferingSkus);

export const guardPlanLimitConfigs: PlanLimitConfigs[] = [
	{
		planName: 'Standard',
		offeringSku: guardOfferingSkus.standard,
		recommendationLimit: 0,
		signupLimit: 50_000,
	},
	{
		planName: 'Premium',
		offeringSku: guardOfferingSkus.premium,
		recommendationLimit: 99,
		signupLimit: 50_000,
	},
];

export const guardBillingCycleConfig: BillingCycleConfig = {
	monthly: true,
	annual: true,
};
